<script>
export default {
    components: {},
    computed: {},
    watch: {},
    data() {
        return {
            loading: false
        }
    },
    methods: {},
}
</script>

<template>
    <div>
        <header-image kicker="Autos und Strecken">
            <h1>Autos &amp; Strecken entdecken</h1>
        </header-image>

        <b-container class="mt-3 mb-5" v-if="!loading">
            <router-view />
        </b-container>
    </div>
</template>

<style lang="scss" scoped>
</style>
